import { useMutation, useQueryClient } from '@tanstack/react-query';
import { approveAccountDocument } from '../endpoints/accountDocument.ts';
import type { ApproveAccountDocumentParams } from '../model.ts';
import { ACCOUNT_DOCUMENT_QUERY_NAMESPACE } from './useAccountDocumentList.ts';

const useApproveAccountDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      params,
    }: {
      id: string;
      params: ApproveAccountDocumentParams;
    }) => approveAccountDocument(id, params),
    // 失敗時（例如併發被他人審掉的 409）也要重抓，讓畫面回到後端的真實狀態
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: [ACCOUNT_DOCUMENT_QUERY_NAMESPACE],
      }),
  });
};

export { useApproveAccountDocument };
